/**
 * vitaminb-section.js
 *
 * 1. Sticky TOC: first item active by default, updates on scroll
 * 2. Banner search: Find button scrolls to matching tab + highlights cards
 * 3. Banner dropdown toggle
 * 4. FAQ: always open — no JS needed (rendered as plain divs in Liquid)
 */

(function () {
  'use strict';

  /* ─────────────────────────────────────────────
     BANNER DROPDOWN
  ───────────────────────────────────────────── */
  function initBanners() {
    document.querySelectorAll('[data-banner-filter]').forEach(function (wrap) {
      var dropBtn   = wrap.querySelector('.vitaminb-banner__filter-dropdown-btn');
      var dropList  = wrap.querySelector('.vitaminb-banner__filter-dropdown-list');
      var dropLabel = wrap.querySelector('.vitaminb-banner__filter-dropdown-label');
      var opts      = wrap.querySelectorAll('.vitaminb-banner__filter-opt');

      if (!dropBtn || !dropList) return;

      dropBtn.addEventListener('click', function () {
        var open = dropBtn.getAttribute('aria-expanded') === 'true';
        dropBtn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if (open) { dropList.setAttribute('hidden', ''); }
        else       { dropList.removeAttribute('hidden'); }
      });

      document.addEventListener('click', function (e) {
        if (!wrap.contains(e.target)) {
          dropBtn.setAttribute('aria-expanded', 'false');
          dropList.setAttribute('hidden', '');
        }
      });

      opts.forEach(function (opt) {
        opt.addEventListener('click', function () {
          opts.forEach(function (o) { o.classList.remove('is-active'); });
          opt.classList.add('is-active');
          if (dropLabel) dropLabel.textContent = opt.textContent.trim();
          dropBtn.setAttribute('aria-expanded', 'false');
          dropList.setAttribute('hidden', '');
        });
      });
    });
  }

  /* ─────────────────────────────────────────────
     BANNER SEARCH
     When user clicks Find: read input + selected dropdown filter,
     scroll to the first matching tab group, show a results panel
     above the main content area with matching cards cloned into it.
  ───────────────────────────────────────────── */
  function initBannerSearch(sectionId) {
    var input      = document.getElementById('vitaminb-banner-search-' + sectionId);
    var trigger    = document.querySelector('[data-banner-search-trigger="' + sectionId + '"]');
    var main       = document.querySelector('[data-cluster-main="' + sectionId + '"]');
    var resultsWrap = document.querySelector('[data-search-results="' + sectionId + '"]');
    var closeBtn   = document.querySelector('[data-search-close="' + sectionId + '"]');
    var dropOpts   = document.querySelectorAll('[data-banner-filter] .vitaminb-banner__filter-opt');

    if (!input || !trigger || !main) return;

    function getActiveFilter() {
      var active = document.querySelector('[data-banner-filter] .vitaminb-banner__filter-opt.is-active');
      return active ? (active.dataset.bannerTabFilter || 'all') : 'all';
    }

    function doSearch() {
      var q = input.value.trim().toLowerCase();
      if (!q) {
        hideResults();
        return;
      }

      var filter      = getActiveFilter(); // 'all' or 'tabkey-blockid'
      var allCards    = main.querySelectorAll('.vitaminb-cluster__card');
      var tabGroups   = main.querySelectorAll('.vitaminb-cluster__tab-group');
      var matched     = [];
      var matchedTabs = {};

      allCards.forEach(function (card) {
        var text    = (card.dataset.cardSearchText || '').toLowerCase();
        var gridEl  = card.closest('.vitaminb-cluster__card-grid');
        var tabKey  = gridEl ? gridEl.dataset.cardTab : '';
        var vtabId  = gridEl ? gridEl.dataset.vtabContent : '';

        // Check tab filter
        var filterMatch = (filter === 'all') || (vtabId && vtabId === filter);
        var textMatch   = text.includes(q);

        // Also match on tab heading
        var tabGroup = vtabId ? main.querySelector('[data-vtab-group="' + vtabId + '"]') : null;
        var tabHeadingMatch = tabGroup ? (tabGroup.dataset.tabHeading || '').includes(q) : false;

        if (filterMatch && (textMatch || tabHeadingMatch)) {
          matched.push(card);
          if (vtabId) matchedTabs[vtabId] = tabGroup;
        }
      });

      if (matched.length === 0) {
        showResults(matched, null, q);
        return;
      }

      // Find first matched tab group and scroll to it
      var firstTabId  = Object.keys(matchedTabs)[0];
      var firstTabEl  = firstTabId ? main.querySelector('[data-vtab-group="' + firstTabId + '"]') : null;

      showResults(matched, matchedTabs, q);

      // if (firstTabEl) {
      //   var top = firstTabEl.getBoundingClientRect().top + window.pageYOffset - 100;
      //   setTimeout(function () {
      //     window.scrollTo({ top: top, behavior: 'smooth' });
      //   }, 100);
      // } else if (resultsWrap) {
      //   var top2 = resultsWrap.getBoundingClientRect().top + window.pageYOffset - 100;
      //   setTimeout(function () {
      //     window.scrollTo({ top: top2, behavior: 'smooth' });
      //   }, 100);
      // }
    }

    function showResults(cards, tabGroups, q) {
      if (!resultsWrap) return;
      var inner = resultsWrap.querySelector('.vitaminb-cluster__search-results-inner');
      if (!inner) return;

      inner.innerHTML = '';

      if (cards.length === 0) {
        inner.innerHTML = '<p style="color:#888;font-size:0.875rem;grid-column:1/-1;">No results found for &ldquo;' + q + '&rdquo;</p>';
      } else {
        cards.forEach(function (card) {
          var clone = card.cloneNode(true);
          clone.style.cssText = '';
          inner.appendChild(clone);
        });
      }

      resultsWrap.removeAttribute('hidden');
    }

    function hideResults() {
      if (!resultsWrap) return;
      resultsWrap.setAttribute('hidden', '');
      var inner = resultsWrap.querySelector('.vitaminb-cluster__search-results-inner');
      if (inner) inner.innerHTML = '';
    }

    trigger.addEventListener('click', doSearch);

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') doSearch();
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        hideResults();
        input.value = '';
      });
    }
  }

  /* ─────────────────────────────────────────────
     STICKY TOC — active item updates on scroll
  ───────────────────────────────────────────── */
  function initStickyTOC(clusterEl) {
    var navLinks = clusterEl.querySelectorAll('[data-vtab-nav]');
    var tocItems = clusterEl.querySelectorAll('.vitaminb-cluster__toc-item');
    var tabGroups = Array.from(clusterEl.querySelectorAll('[data-vtab-group]'));

    if (!tabGroups.length) return;

    /* Click: scroll only */
    navLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var target = link.dataset.vtabNav;
        setActive(target);

        var group = clusterEl.querySelector('[data-vtab-group="' + target + '"]');
        if (group) {
          var top = group.getBoundingClientRect().top + window.pageYOffset - 80;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      });
    });

    /* Scroll: update active TOC item based on which tab group is in view */
    function onScroll() {
      var scrollY   = window.scrollY || window.pageYOffset;
      var winHeight = window.innerHeight;
      var active    = null;

      /* Find the tab group whose top is closest to (but not below) 40% of viewport */
      var threshold = scrollY + winHeight * 0.4;

      tabGroups.forEach(function (group) {
        var rect = group.getBoundingClientRect();
        var top  = rect.top + scrollY;
        if (top <= threshold) {
          active = group.dataset.vtabGroup;
        }
      });

      if (active) setActive(active);
    }

    function setActive(target) {
      navLinks.forEach(function (l) { l.classList.toggle('is-active', l.dataset.vtabNav === target); });
      tocItems.forEach(function (item) {
        var l = item.querySelector('[data-vtab-nav]');
        if (l) item.classList.toggle('is-active', l.dataset.vtabNav === target);
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // run once on load
  }

  /* ─────────────────────────────────────────────
     HIDE TAB COUNT WHEN ZERO
  ───────────────────────────────────────────── */
  function hideZeroTabCounts(clusterEl) {
    var countElements = clusterEl.querySelectorAll('.vitaminb-cluster__tab-count');
    countElements.forEach(function (el) {
      var text = el.textContent.trim();
      var match = text.match(/\d+/);
      var count = match ? parseInt(match[0], 10) : 0;
      if (count === 0) {
        el.style.display = 'none';
      }
    });
  }

  /* ─────────────────────────────────────────────
     INIT
  ───────────────────────────────────────────── */
  function init() {
    initBanners();

    /* Find all section IDs */
    document.querySelectorAll('.vitaminb-cluster[data-section-id]').forEach(function (clusterEl) {
      var sectionId = clusterEl.dataset.sectionId;
      initBannerSearch(sectionId);
      initStickyTOC(clusterEl);
      hideZeroTabCounts(clusterEl);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initBanners();
    e.target.querySelectorAll('.vitaminb-cluster[data-section-id]').forEach(function (clusterEl) {
      var sectionId = clusterEl.dataset.sectionId;
      initBannerSearch(sectionId);
      initStickyTOC(clusterEl);
      hideZeroTabCounts(clusterEl);
    });
  });

})();